import React from 'react';
import { euros, remiseMaxBonusRepar } from '../../../annuaire/bonusRepar';

/**
 * Le Bonus Répar en une ligne du récapitulatif gris du tunnel, à côté de
 * l'adresse, du problème et du créneau : à poser dans un `<dl>`. Le barème y
 * est dit en entier, sans bloc à part (choix de Clément du 14/10).
 *
 * `nue` : la paire `dt`/`dd` sans `div`, pour un `<dl>` dont les autres
 * entrées sont aussi des `dt`/`dd` nus (la colonne de droite du tunnel) : le
 * HTML ne permet pas de mêler les deux formes dans une même liste.
 *
 * Aucun montant n'est promis à ce client en particulier : le seuil porte sur
 * ses réparations éligibles, que l'atelier juge à la facture. Le texte parle
 * donc de la facture, jamais de la réservation, qui peut n'être qu'une demande.
 */
export default function LigneBonusRepar({ paliers, nue = false }) {
  if (!paliers || paliers.length === 0) return null;
  const texte = (
    <>
      <b>Atelier labellisé.</b> {remiseMaxBonusRepar(paliers)} sur votre facture
      :{' '}
      {paliers.map((p, i) => (
        <span key={p.seuil}>
          {i > 0 && ', '}
          {euros(p.montant)} dès {euros(p.seuil)}
        </span>
      ))}{' '}
      de réparations éligibles.
    </>
  );
  if (nue)
    return (
      <>
        <dt>Bonus Répar</dt>
        <dd data-testid="bonus-repar">{texte}</dd>
      </>
    );
  return (
    <div data-testid="bonus-repar">
      <dt>Bonus Répar</dt>
      <dd>{texte}</dd>
    </div>
  );
}
